<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/turmas">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select dense label="Sala de aula" v-model="dataset.data.class_room_id"
                                                required :items="dataset.classRooms" item-text="name" item-value="id"
                                                outlined hide-details="auto">
                                            </v-select>
                                        </v-col>

                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-select dense label="Ensino" v-model="dataset.data.education_id" required
                                                :items="dataset.educations" item-text="name" item-value="id" outlined
                                                hide-details="auto">
                                            </v-select>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <v-select dense label="Período" v-model="dataset.data.day_shift" required
                                                :items="dataset.dayPeriods" item-text="name" item-value="id" outlined
                                                hide-details="auto">
                                            </v-select>
                                        </v-col>

                                    </v-row>

                                    <v-row>

                                        <v-col cols="12" sm="3">
                                            <v-text-field dense type="time" label="Inicio Aula"
                                                v-model="dataset.data.start_time" required :rules="[$rules.required]"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="3">
                                            <v-text-field dense type="time" label="Fim Aula"
                                                v-model="dataset.data.end_time" required :rules="[$rules.required]"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="3">
                                            <v-text-field dense type="time" label="Inicio Intervalo"
                                                v-model="dataset.data.interval_start_time" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="3">
                                            <v-text-field dense type="time" label="Fim Intervalo"
                                                v-model="dataset.data.interval_end_time" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-textarea dense label="Descrição" v-model="dataset.data.description"
                                                outlined rows="2" hide-details="auto">
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

        </v-form>

        <v-row v-if="!page.isNew">
            <v-col cols="12">
                <class-components-panel
                    :offerings="dataset.offerings"
                    :courses="dataset.courses"
                    :teachers="dataset.teachers"
                    :loading="dataForm.componentLoading"
                    @create-offering="createOffering"
                    @update-offering="updateOffering"
                    @add-teacher="addOfferingTeacher"
                    @delete-teacher="deleteOfferingTeacher"
                    @delete-offering="deleteOffering"
                />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined">
                            <v-card-title class="academic-panel-title">
                                <div>
                                    <span>Grade semanal</span>
                                    <small>Distribua na semana os componentes e docentes já vinculados à turma.</small>
                                </div>
                            </v-card-title>

                            <v-card-text v-if="!page.isNew">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-select dense label="Componente da turma"
                                            v-model="dataset.scheduleData.class_component_id"
                                            required :items="dataset.offerings" :item-text="offeringLabel" item-value="id" outlined
                                            hide-details="auto">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select dense label="Professor" v-model="dataset.scheduleData.teacher_id"
                                            required :items="scheduleTeachers" item-text="name" item-value="id" outlined
                                            :disabled="!dataset.scheduleData.class_component_id"
                                            hide-details="auto">
                                        </v-select>
                                    </v-col>

                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-select dense label="Dia" v-model="dataset.scheduleData.day" required
                                            :items="dataset.weekDays" item-text="name" item-value="id" outlined
                                            hide-details="auto">
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12" sm="3">
                                        <v-text-field dense type="time" label="Horário de Início"
                                            v-model="dataset.scheduleData.start_time" required
                                            :rules="[$rules.required]" outlined hide-details="auto">
                                        </v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="3">
                                        <v-text-field dense type="time" label="Horário de Término"
                                            v-model="dataset.scheduleData.end_time" required :rules="[$rules.required]"
                                            outlined hide-details="auto">
                                        </v-text-field>
                                    </v-col>


                                </v-row>

                                <v-row>
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="primary" dark
                                            :loading="dataForm.scheduleLoading"
                                            @click="saveTimeline">Adicionar à grade</v-btn>
                                    </v-col>
                                </v-row>

                            </v-card-text>
                            <v-card-text v-else>
                                <v-row>
                                    <v-col>
                                        <p class="body-2">Cronograma disponível apenas na edição da
                                            <strong>turma</strong>.
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-title class="card-group-title">Visão da semana</v-card-title>

                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-calendar ref="calendar" type="week" locale="pt-BR" :short-weekdays="false"
                                            :weekdays="weekdayLabels" event-color="primary" color="indigo lighten-4"
                                            :events="dataset.schedules" :now="now" @click:event="openEventDetails">

                                            <template v-slot:event="{ event }">
                                                <strong>{{ event.course.name }}</strong><br>
                                                <span>{{ event.start_time }} - {{ event.end_time }}</span><br />
                                            </template>

                                        </v-calendar>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <!-- <v-card-text>
                                    <v-row class="mt-5" v-if="dataset.data.schedules.length"> -->
                            <!-- <v-col cols="12">
                                            <v-row>
                                                <v-col v-for="(day, index) in dataset.weekDays" :key="index" cols="12"
                                                    md="4">
                                                    <v-card class="pa-3 mb-3">
                                                        <v-card-title>{{ day.name }}</v-card-title>
                                                        <v-card-text>
                                                            <v-list dense>
                                                                <v-list-item
                                                                    v-for="(timeline, index) in getTimelineForDay(day.id)"
                                                                    :key="index">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            {{ getCourseByID(timeline.course_id).name }}
                                                                        </v-list-item-title>
                                                                        <v-list-item-subtitle>
                                                                            <strong>Professor: </strong>
                                                                            {{ getTeacherByID(timeline.teacher_id).name
                                                                            }}
                                                                        </v-list-item-subtitle>
                                                                        <v-list-item-subtitle>
                                                                            <strong>Horário:</strong> {{
                                                                                timeline.start_time }} - {{
                                                                                timeline.end_time }}
                                                                        </v-list-item-subtitle>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                                <v-list-item v-if="getTimelineForDay(day.id).length === 0">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>Nenhuma aula
                                                                            cadastrada</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-col> -->
                            <!-- <v-col v-for="(timeline, index) in dataset.timelines" :key="index" cols="12">
                                            <v-card class="pa-3">
                                                <v-card-title>{{ timeline.day }}</v-card-title>
                                                <v-row>
                                                    <v-col v-for="classItem in day.classes" :key="classItem.start"
                                                        :cols="calculateCols(classItem)">
                                                        <v-chip color="primary" class="pa-2 white--text">
                                                            {{ classItem.subject }} ({{ formatTime(classItem.start) }} -
                                                            {{ formatTime(classItem.end) }})
                                                        </v-chip>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-col> -->
                            <!-- <v-col>
                                            <v-expansion-panels>
                                                <v-expansion-panel v-for="(item, index) in dataset.timelines"
                                                    :key="index">
                                                    <v-expansion-panel-header>
                                                        <div>
                                                            <strong>Máteria: </strong>
                                                            <span>
                                                                {{ getCourseByID(item.course_id).name }}
                                                            </span> /
                                                            <strong>Professor: </strong>
                                                            <span>
                                                                {{ getTeacherByID(item.teacher_id).name }}
                                                            </span>
                                                        </div>
                                                    </v-expansion-panel-header>
                                                    <v-expansion-panel-content>
                                                        <v-row>
                                                            <v-col>
                                                                <span class="section-info-title">Horários</span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-for="(schedule, index) in item.schedules" :key="index">
                                                            <v-col>
                                                                <span class="section-info-value text-uppercase">
                                                                    - {{ getWeekDay(schedule.day).name }} ({{
                                                                        schedule.start_time }} até {{
                                                                        schedule.end_time
                                                                    }})
                                                                </span>
                                                                <br>
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-col> -->
                            <!-- </v-row>
                                    <v-row v-else>
                                        <v-col>
                                            <p class="body-2">Nenhum cronograma adicionado</p>
                                        </v-col>
                                    </v-row>
                                </v-card-text> -->
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="!page.isNew">
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="academic-panel-title">
                        <div>
                            <span>Equipe de apoio da turma</span>
                            <small>Regentes, auxiliares, monitores e coordenação. Professores de componentes são vinculados acima.</small>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center">
                            <v-col cols="12" md="5">
                                <v-select dense label="Colaborador" v-model="dataset.staffData.employee_id"
                                    :items="dataset.employees" item-text="name" item-value="id" outlined
                                    hide-details="auto">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select dense label="Função" v-model="dataset.staffData.role"
                                    :items="dataset.staffRoles" item-text="name" item-value="id" outlined
                                    hide-details="auto">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-checkbox dense label="Principal" v-model="dataset.staffData.is_primary"
                                    hide-details></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-btn type="button" elevation="0" color="primary" dark @click="saveStaff"
                                    :loading="dataForm.staffLoading">Adicionar</v-btn>
                            </v-col>
                        </v-row>

                        <v-data-table
                            class="app-table mt-4"
                            :headers="dataset.staffHeaders"
                            :items="dataset.staff"
                            :disable-sort="true"
                            hide-default-footer
                            no-data-text="Nenhum colaborador vinculado à turma"
                        >
                            <template v-slot:[`item.employee`]="{ item }">
                                {{ item.employee ? item.employee.name : "N/A" }}
                            </template>
                            <template v-slot:[`item.role`]="{ item }">
                                {{ staffRoleLabel(item.role) }}
                            </template>
                            <template v-slot:[`item.is_primary`]="{ item }">
                                {{ item.is_primary ? "Sim" : "Não" }}
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon @click="deleteStaff(item)" size="large">mdi-delete-outline</v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" v-if="selectedEvent" max-width="400px">
            <v-card>
                <v-card-title class="headline">{{ selectedEvent.course.name }}</v-card-title>
                <v-card-text>
                    <strong>Professor:</strong> {{ selectedEvent.teacher.name }}<br />
                    <strong>Horário:</strong> {{ selectedEvent.start_time }} - {{ selectedEvent.end_time }}
                </v-card-text>
                <v-card-actions>
                    <v-btn type="button" elevation="0" color="primary" dark @click="deleteSchedule">Excluir</v-btn>
                    <v-btn class="ml-4" type="button" elevation="0" color="primary" text
                        @click="dialog = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import string from "@/common/util/string"

import dayPeriods from "@/common/data/day-periods.data"
import weekDays from "@/common/data/week-days.data"

import axios from "axios"
import ClassComponentsPanel from "./components/ClassComponentsPanel.vue"

export default {
    name: "ClassDetails",

    components: {
        ClassComponentsPanel,
    },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            data: {
                schedules: [],
            },
            scheduleData: {
                teacher_id: null,
                class_component_id: null,
            },
            schedules: [],
            educations: [],
            classRooms: [],
            teachers: [],
            courses: [],
            offerings: [],
            employees: [],
            staff: [],
            staffData: {
                employee_id: null,
                role: "assistant",
                is_primary: false,
            },
            staffRoles: [
                { id: "teacher", name: "Professor(a) regente" },
                { id: "assistant", name: "Auxiliar" },
                { id: "monitor", name: "Monitor(a)" },
                { id: "coordinator", name: "Coordenação" },
            ],
            staffHeaders: [
                { text: "Colaborador", value: "employee" },
                { text: "Função", value: "role" },
                { text: "Principal", value: "is_primary" },
                { text: "Ações", value: "actions", sortable: false },
            ],
            dayPeriods: dayPeriods,
            weekDays: weekDays,
        },

        weekdayLabels: [1, 2, 3, 4, 5, 6, 0],
        now: new Date().toISOString().slice(0, 10),
        dialog: false,
        selectedEvent: null,

        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            staffLoading: false,
            componentLoading: false,
            scheduleLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },

    }),

    computed: {
        scheduleTeachers() {
            const offering = this.dataset.offerings.find(
                (item) => Number(item.id) === Number(this.dataset.scheduleData.class_component_id)
            );
            if (!offering) return [];
            return (offering.teachers || [])
                .map((assignment) => assignment.employee)
                .filter(Boolean);
        },
    },

    watch: {
        "dataset.scheduleData.class_component_id"() {
            this.dataset.scheduleData.teacher_id = null;
        },
    },

    created() {
        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/turmas");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            await this.load();
            await this.loadEducations();
            await this.loadTeachers();
            await this.loadEmployees();
            await this.loadCourses();
            await this.loadClassRooms();
            await this.loadOfferings();
            await this.loadStaff();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Nova turma' : 'Detalhes da turma'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Turmas",
                disabled: false,
                to: "/turmas",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/v1/classes/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

                this.dataset.schedules = this.dataset.data.schedules.map((x) => {
                    const currentDate = new Date();
                    const currentIsoDay = currentDate.getDay() === 0 ? 7 : currentDate.getDay();
                    currentDate.setDate(currentDate.getDate() + (Number(x.day) - currentIsoDay));

                    return { ...x, start: this.convertTimeToDate(currentDate, x.start_time), end: this.convertTimeToDate(currentDate, x.end_time) }
                })

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadEducations() {

            try {
                const result = await axios.get(`/api/v1/educations`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.educations = result.data.content.data;

                console.log("educations: ", this.dataset.educations)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadTeachers() {

            try {

                const result = await axios.get(`/api/v1/employees`, { params: { start: 1, limit: 100000, search: JSON.stringify({ type: 4 }) } });

                this.dataset.teachers = result.data.content.data;

                console.log("teachers: ", this.dataset.teachers)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadEmployees() {

            try {

                const result = await axios.get(`/api/v1/employees`, { params: { start: 1, limit: 100000, search: JSON.stringify({}) } });

                this.dataset.employees = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadCourses() {

            try {

                const result = await axios.get(`/api/v1/courses`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.courses = result.data.content.data;

                console.log("courses: ", this.dataset.courses)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadClassRooms() {

            try {
                const result = await axios.get(`/api/v1/class-rooms`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.classRooms = result.data.content.data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadStaff() {
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/v1/classes/${this.$route.params.id}/staff`);
                this.dataset.staff = result.data.content || [];
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadOfferings() {
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/v1/classes/${this.$route.params.id}/components`);
                this.dataset.offerings = (result.data.content && result.data.content.data) || [];
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 2000,
                });
            }
        },

        offeringLabel(offering) {
            if (!offering) return "Componente";
            const course = offering.course ? offering.course.name : "Componente";
            const teachers = (offering.teachers || [])
                .map((assignment) => assignment.employee && assignment.employee.name)
                .filter(Boolean);
            return teachers.length ? `${course} · ${teachers.join(", ")}` : `${course} · sem professor`;
        },

        async createOffering(payload) {
            this.dataForm.componentLoading = true;
            try {
                await axios.post(`/api/v1/classes/${this.$route.params.id}/components`, payload);
                this.$dialog.notify.info("Componente adicionado à turma.", {
                    position: "top-right",
                    timeout: 1600,
                });
                await this.loadOfferings();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 2500,
                });
            } finally {
                this.dataForm.componentLoading = false;
            }
        },

        async updateOffering({ offering, data }) {
            this.dataForm.componentLoading = true;
            try {
                await axios.patch(
                    `/api/v1/classes/${this.$route.params.id}/components/${offering.id}`,
                    data
                );
                this.$dialog.notify.info("Carga horária atualizada.", {
                    position: "top-right",
                    timeout: 1600,
                });
                await this.loadOfferings();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 2500,
                });
            } finally {
                this.dataForm.componentLoading = false;
            }
        },

        async addOfferingTeacher({ offering, teacher }) {
            this.dataForm.componentLoading = true;
            try {
                await axios.post(
                    `/api/v1/classes/${this.$route.params.id}/components/${offering.id}/teachers`,
                    { ...teacher, role: "teacher" }
                );
                this.$dialog.notify.info("Professor vinculado ao componente.", {
                    position: "top-right",
                    timeout: 1600,
                });
                await this.loadOfferings();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 2500,
                });
            } finally {
                this.dataForm.componentLoading = false;
            }
        },

        async deleteOfferingTeacher({ assignment }) {
            this.dataForm.componentLoading = true;
            try {
                await axios.delete(
                    `/api/v1/classes/${this.$route.params.id}/components/${assignment.class_component_id}/teachers/${assignment.id}`
                );
                await this.loadOfferings();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 2500,
                });
            } finally {
                this.dataForm.componentLoading = false;
            }
        },

        async deleteOffering(offering) {
            const confirmed = await this.$dialog.confirm({
                title: "Remover componente",
                text: "Deseja remover este componente da turma?",
                actions: { false: "Cancelar", true: "Remover" },
            });
            if (!confirmed) return;

            this.dataForm.componentLoading = true;
            try {
                await axios.delete(
                    `/api/v1/classes/${this.$route.params.id}/components/${offering.id}`
                );
                await this.loadOfferings();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 2500,
                });
            } finally {
                this.dataForm.componentLoading = false;
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja adicionar a turma?',
                title: 'Incluir turma',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                await axios.post('/api/v1/classes', payload);
                this.$dialog.notify.info("Turma adicionada com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });
                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados da turma?',
                title: 'Atualizar turma',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v1/classes/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Turma atualizada com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        getTimelineForDay(day) {
            return this.dataset.data.schedules.filter(item => item.day === day);
        },

        async saveTimeline() {
            if (this.dataset.scheduleData.teacher_id == null || this.dataset.scheduleData.class_component_id == null || this.dataset.scheduleData.day == null || this.dataset.scheduleData.start_time == null || this.dataset.scheduleData.end_time == null) {
                this.$dialog.notify.warning("Preencha componente, professor, dia e horários da aula.", {
                    position: "top-right",
                    timeout: 2200,
                });
                return;
            }

            const data = {
                teacher_id: this.dataset.scheduleData.teacher_id,
                class_component_id: this.dataset.scheduleData.class_component_id,
                day: this.dataset.scheduleData.day,
                start_time: this.dataset.scheduleData.start_time,
                end_time: this.dataset.scheduleData.end_time,
                class_id: this.dataset.data.id
            }

            this.dataForm.scheduleLoading = true;

            try {
                await axios.post(`/api/v1/classes/schedules`, data);

                this.$dialog.notify.info("Aula adicionada à grade semanal.", { position: "top-right", timeout: 2000 });

                this.dataset.scheduleData = {
                    teacher_id: null,
                    class_component_id: null,
                };
                await this.load()
                await this.loadOfferings()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.scheduleLoading = false;
            }
        },

        async deleteSchedule() {
            if (!this.selectedEvent) return;

            try {
                const response = await axios.delete(`/api/v1/classes/schedules/${this.selectedEvent.id}`);

                this.$dialog.notify.info("Cronograma atualizado com sucesso!", { position: "top-right", timeout: 2000 });

                this.selectedEvent = null;
                this.dialog = false;

                this.load()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async saveStaff() {
            if (!this.dataset.staffData.employee_id || !this.dataset.staffData.role) return;

            this.dataForm.staffLoading = true;

            try {
                await axios.post(`/api/v1/classes/${this.$route.params.id}/staff`, this.dataset.staffData);

                this.$dialog.notify.info("Equipe da turma atualizada com sucesso!", { position: "top-right", timeout: 2000 });

                this.dataset.staffData = {
                    employee_id: null,
                    role: "assistant",
                    is_primary: false,
                };

                await this.loadStaff();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.staffLoading = false;
            }
        },

        async deleteStaff(item) {
            try {
                await axios.delete(`/api/v1/classes/staff/${item.id}`);

                this.$dialog.notify.info("Equipe da turma atualizada com sucesso!", { position: "top-right", timeout: 2000 });
                await this.loadStaff();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        staffRoleLabel(role) {
            const item = this.dataset.staffRoles.find((staffRole) => staffRole.id === role);
            return item ? item.name : role;
        },

        getTeacherByID(id) {
            return this.dataset.teachers.find((x) => x.id == id)
        },

        getCourseByID(id) {
            return this.dataset.courses.find((x) => x.id == id)
        },

        getWeekDay(id) {
            return this.dataset.weekDays.find((x) => x.id == id)
        },

        openEventDetails({ event }) {
            this.selectedEvent = event;
            this.dialog = true;
        },

        convertTimeToDate(baseDate, time) {
            const [hours, minutes] = time.split(':');
            const date = new Date(baseDate);
            date.setHours(parseInt(hours));
            date.setMinutes(parseInt(minutes));
            return this.$moment(date).format('YYYY-MM-DD HH:mm');
        },

        buildPayload() {
            let data = {
                name: this.dataset.data.name,
                description: this.dataset.data.description,
                day_shift: this.dataset.data.day_shift,
                education_id: this.dataset.data.education_id,
                class_room_id: this.dataset.data.class_room_id,
                start_time: this.dataset.data.start_time,
                end_time: this.dataset.data.end_time,
                interval_start_time: this.dataset.data.interval_start_time,
                interval_end_time: this.dataset.data.interval_end_time,
            }

            if (this.page.isNew) {
                data.schedules = this.dataset.data.schedules
            }

            return data;
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-subtitle {
    font-weight: 500;
    font-size: 14px;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

.outlined-time {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 4px 8px;
    margin-bottom: 8px;
}

.academic-panel-title span,
.academic-panel-title small {
    display: block;
}

.academic-panel-title small {
    color: #64748b;
    font-size: 12px;
    font-weight: 500;
    margin-top: 3px;
}
</style>
